import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot } from "@angular/router";
import { ConfigurationService } from "../../configuration.service";

@Injectable()
export class RedirectorGuard implements CanActivate {

  constructor(
    private router: Router, private configurationService: ConfigurationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let val: Params = route.queryParams;

    if (val && val["c-sig"]) {
      return true
    }
    console.log(val["utm_source"])
    const queryParams = {
      "c-sig": this.configurationService.config
    };
    var params = { ...val, ...queryParams };
    this.router.navigate([`/${route.routeConfig.path}`], { queryParams: params });
  }
}
